import unfetch from 'unfetch'

// Keep other application requests on their existing transport. Register reads
// need real cancellation so Apollo removes timed-out requests from deduplication.
export default function registerFetch(url, options = {}) {
  if (!options.registerDeadline) return unfetch(url, options)
  const { registerDeadline, ...requestOptions } = options
  if (requestOptions.signal && typeof window.fetch === 'function') return window.fetch(url, requestOptions).catch(error => {
    // Apollo Link HTTP 1.x swallows AbortError without completing its observable.
    // Deadline cancellation must reject it so Retry is not deduplicated onto it.
    if (error && error.name === 'AbortError') throw new Error('Register request aborted')
    throw error
  })

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const signal = requestOptions.signal
    let settled = false
    const finish = (error, response) => {
      if (settled) return
      settled = true
      if (signal) signal.removeEventListener('abort', abort)
      if (error) reject(error)
      else resolve(response)
    }
    const abort = () => {
      const error = new Error('Register request aborted')
      xhr.abort()
      finish(error)
    }
    if (signal && signal.aborted) return abort()
    xhr.open(requestOptions.method || 'GET', url, true)
    xhr.timeout = 10000
    xhr.withCredentials = requestOptions.credentials === 'include'
    for (const [key, value] of Object.entries(requestOptions.headers || {})) xhr.setRequestHeader(key, value)
    xhr.onload = () => finish(null, {
      status: xhr.status,
      statusText: xhr.statusText,
      ok: xhr.status >= 200 && xhr.status < 300,
      headers: { get: name => xhr.getResponseHeader(name) },
      text: () => Promise.resolve(xhr.responseText),
    })
    xhr.onerror = () => finish(new Error('Register network request failed'))
    xhr.ontimeout = () => finish(new Error('Register request timed out'))
    xhr.onabort = () => {
      const error = new Error('Register request aborted')
      finish(error)
    }
    if (signal) signal.addEventListener('abort', abort, { once: true })
    xhr.send(requestOptions.body || null)
  })
}
